var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFeedback(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.001 12.6V16.2C27.001 21 24.601 23.4 19.801 23.4H19.201C18.829 23.4 18.469 23.58 18.241 23.88L16.441 26.28C15.649 27.336 14.353 27.336 13.561 26.28L11.761 23.88C11.569 23.616 11.125 23.4 10.801 23.4H10.201C5.40098 23.4 3.00098 22.2 3.00098 16.2V10.2C3.00098 5.4 5.40098 3 10.201 3H17.401",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.001 9C25.6578 9 27.001 7.65685 27.001 6C27.001 4.34315 25.6578 3 24.001 3C22.3441 3 21.001 4.34315 21.001 6C21.001 7.65685 22.3441 9 24.001 9Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7965 13.8002H19.8073",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9948 13.8002H15.0056",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.194 13.8002H10.2048",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFeedback);
export default __webpack_public_path__ + "static/media/icon-feedback.74742743fc33f17ea493a472ab1cd6b5.svg";
export { ForwardRef as ReactComponent };